// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610090435/js/" + chunkId + "." + {"44":"e022424c","225":"01925e7b","481":"adfb2bab","486":"c968c331","770":"b55b0360"}[chunkId] + ".0.5414615137609203.chunk.js";
};